import { setTab, tabs } from '../../store';
import { Box, Tabs } from '@servicepipe/ui-components';
import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const NetworkProtectionTabs = ({ queryParams }) => {
  const [, setSearchParams] = useSearchParams();

  const tabItems = useMemo(() => tabs.map(({ tab, title }) => ({ key: tab, title })), []);

  return (
    <Box direction="column" gap="35px">
      <Tabs
        tabs={tabItems}
        selectedTab={queryParams.tab}
        setTab={(value) => setTab(value, setSearchParams)}
      />
    </Box>
  );
};
